import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

// Google Maps place for "Avishka Navya Collections"
export const MAP_EMBED_URL = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3847.5681133392577!2d75.10206307493934!3d15.345688485233785!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bb8d7638994c45f%3A0x4a52bf2f23511959!2sAvishkaNavya%20Collections!5e0!3m2!1sen!2sin!4v1791628298257!5m2!1sen!2sin";
export const DEFAULT_INSTAGRAM = "https://www.instagram.com/avishkanavya_collections/";
export const DIRECTIONS_URL = "https://maps.google.com/?cid=5355553116073826649";

/** Store details edited in Admin → Settings (address, phone, WhatsApp, email, hours, social links). */
export function useSiteSettings() {
  const { data } = useQuery({ queryKey: ["settings"], queryFn: () => api.get("/settings").then((r) => r.data), staleTime: 5 * 60 * 1000 });
  const s = data || {};
  return {
    loaded: !!data,
    name: s.business_name || "Avishka Navya Collections",
    address: s.business_address || "",
    phone: s.business_phone || "",
    whatsapp: s.business_whatsapp || s.business_phone || "",
    email: s.business_email || "hello@avishkanavya.com",
    hours: s.business_hours || "",
    instagram: s.instagram_url || DEFAULT_INSTAGRAM,
    facebook: s.facebook_url || "",
    youtube: s.youtube_url || "",
  };
}

export const telHref = (phone) => `tel:${(phone || "").replace(/[^\d+]/g, "")}`;
export const waHref = (phone, text = "") => {
  let d = (phone || "").replace(/\D/g, "");
  if (d.length === 11 && d.startsWith("0")) d = d.slice(1);   // 099721 58837 → 9972158837
  if (d.length === 10) d = `91${d}`;
  return `https://wa.me/${d}${text ? `?text=${encodeURIComponent(text)}` : ""}`;
};
